import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_STORE,
  HTTP_METHOD_PUT,
} from '@/common/utils/request.const'

export const putUpcomingPayments = async ({ productId }) => {
  const url = `${API_BASE_URL_STORE}/v1/upcoming-payments`
  try {
    const response = await apiRequest({
      url,
      method: HTTP_METHOD_PUT,
      data: {
        product_id: productId,
      },
    })
    return response
  } catch (error) {
    return {
      error: error.response,
    }
  }
}
